import React, { useState, useEffect } from 'react';
import { Menu, X, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  const navigateToJobs = () => {
    window.location.href = '/jobs';
    setIsMobileMenuOpen(false);
  };

  const openWhatsApp = () => {
    window.open('https://wa.me/4915216817165', '_blank');
  };

  const navItems = [
    { label: 'Home', id: 'hero' },
    { label: 'Unsere Leistungen', id: 'courses' },
    { label: 'Über uns', id: 'about' },
    { label: 'Kontakt', id: 'contact' },
    { label: 'Jobs', action: navigateToJobs, isExternal: true }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20 md:h-28">
          {/* Logo */}
          <div 
            className="flex items-center cursor-pointer group"
            onClick={() => scrollToSection('hero')}
          >
            <img 
              src="/images/davinci-logo-new.png" 
              alt="Da Vinci Institut" 
              className="h-16 md:h-24 transition-transform duration-300 group-hover:scale-105"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.label}
                onClick={item.isExternal ? item.action : () => scrollToSection(item.id)}
                className="text-gray-700 hover:text-teal-600 transition-colors duration-200 font-medium text-sm lg:text-base relative group"
              >
                {item.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-600 transition-all duration-300 group-hover:w-full"></span>
              </button>
            ))}
          </nav>

          {/* CTA Buttons Desktop */}
          <div className="hidden md:flex items-center gap-3">
            <Button
              onClick={openWhatsApp}
              variant="outline"
              className="border-2 border-teal-600 text-teal-600 hover:bg-teal-50 transition-all duration-300"
            >
              <MessageCircle className="w-4 h-4 mr-2" />
              WhatsApp
            </Button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-teal-600 hover:bg-teal-700 text-white transition-all duration-300 hover:shadow-lg hover:scale-105"
            >
              Jetzt anfragen
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-gray-700 hover:text-teal-600 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 ease-in-out overflow-hidden ${
          isMobileMenuOpen ? 'max-h-[32rem] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <nav className="bg-white border-t border-gray-200 px-4 py-4 space-y-3">
          {navItems.map((item) => (
            <button
              key={item.label}
              onClick={item.isExternal ? item.action : () => scrollToSection(item.id)}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:text-teal-600 hover:bg-teal-50 rounded-lg transition-colors duration-200"
            >
              {item.label}
            </button>
          ))}
          <Button
            onClick={openWhatsApp}
            className="w-full bg-teal-600 hover:bg-teal-700 text-white mb-2"
          >
            <MessageCircle className="w-4 h-4 mr-2" />
            WhatsApp Kontakt
          </Button>
          <Button
            onClick={() => scrollToSection('contact')}
            variant="outline"
            className="w-full border-2 border-teal-600 text-teal-600 hover:bg-teal-50"
          >
            Anfrage senden
          </Button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
